import dayjs from "dayjs";

export class MirageConstants {
    public static get EmptyOptionLabel() {
        return "(Empty)";
    }
    public static get CommonRoot() {
        return "common";
    }
    public static get SystemUserName() {
        return "system";
    }
    public static get AdminPanelPermission() {
        return "AdminPanel";
    }
    public static get FoldersDivider() {
        return "\u003e";
    }
    public static get ValidSqlYearRange() {
        return {
            min: 1753,
            max: 9999,
        };
    }
    public static get WorkingHoursRange() {
        return {
            startHour: 7,
            endHour: 19,
        };
    }
    public static get WorkingHoursDayRange() {
        const workingHours = MirageConstants.WorkingHoursRange;
        return {
            start: dayjs().set("hour", workingHours.startHour).set("minute", 0).set("second", 0).set("millisecond", 0),
            end: dayjs().set("hour", workingHours.endHour).set("minute", 0).set("second", 0).set("millisecond", 0),
        };
    }
    public static get DefaultDateFieldHour() {
        return 12;
    }
    public static get MasterLayerUrl() {
        return "https://api.os.uk/maps/raster/v1/zxy/Outdoor_27700/{z}/{x}/{y}.png?key=bf2uPYA6sCW2htgQ2k1cH8NmPE6kdvVC";
    }
    public static get MasterLayerAttribution() {
        return '<a href="https://www.ordnancesurvey.co.uk/governance/crown-copyright" target="_blank">Contains Ordnance Survey data © Crown copyright and database right 2024</a>';
    }

    public static get MaxChunkSize() {
        return 3 * 1024 * 1024;
    }
}
